<style scoped>
  .grouping{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;font-weight: bold;text-align: center;border-bottom: 1px solid #d7dde4;}
  .grouping-content{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;text-align: center;border-bottom: 1px solid #d7dde4;}
	.select-st{width:260px;height: 40px;border-radius:20px;}
</style>

<template>
  <div class="group">
    <Row class="grouping">
      <Col span="12">分组名称</Col>
      <Col span="12">操作</Col>
    </Row>
    <template v-if="groupList.length>0">
      <Row class="grouping-content" v-for="item in groupList">
        <Col span="12">{{item.name}}</Col>
        <Col span="12" style="color: #00a2e9;" v-if="item.change">
        <span @click="openPurviewPanel(item.id)" style="cursor:pointer">分配权限</span> |
        <span @click="resetPanelState = true;resetGroupInfo = item" style="cursor:pointer">重命名</span> |
        <span @click="deleteGroup(item.id)" style="cursor:pointer">删除</span>
        </Col>
        <Col span="12" v-else>当前组权限无法修改</Col>
      </Row>
    </template>
    <!--新增权限组-->
    <Modal
        v-model="createPanelState"
        title="新增权限组"
        @on-ok="addGroup"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding: 20px 0">
        <Col span="6" style="text-align: right">输入权限组名称：</Col>
        <Col span="16"><Input v-model="addGroupNameText" placeholder="请输入权限组的名称"></Input></Col>
      </Row>
    </Modal>
    <!--重命名权限组-->
    <Modal
        v-model="resetPanelState"
        title="重命名权限组"
        @on-ok="resetGroupName"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding: 20px 0">
        <Col span="6" style="text-align: right">输入权限组名称：</Col>
        <Col span="16"><Input v-model="resetGroupInfo.name" placeholder="请输入权限组的名称"></Input></Col>
      </Row>
    </Modal>
    <!--分配权限-->
    <Modal
        v-model="setPurviewPanel"
        width="680"
        @on-ok="setGroupPurview"
        ok-text="保存"
				:closable="false"
    >
		<div style="margin:-16px;">
		<div style="height:50px;background-image:url(/img/setting/head.png);font-size:16px;color:#FFF;line-height:50px;padding-left:20px;">
			请选择需要分配的权限
		</div>
      <Row type="flex" style="padding: 15px  20px 0 20px">
        <Col span="12" v-for="(item,index) in purviewTree" v-if="item.children==undefined" style="text-align: center;margin-bottom:20px;">
          <Row type="flex" align="middle" :gutter="5">
            <Col span="24" style="text-align:left;">
							<span style="font-size:16px">
								<span style="display: inline-block;background-image:url(/img/setting/border-l.png);width:4px;height:16px;vertical-align: middle;"></span>
								{{item.title}}权限
							</span>
							<div style="padding: 5px;"></div>
							<Select v-model="item.type" size="large" transfer-class-name="select-st" style="width:260px;height: 40px;border-radius:20px;">
								<Option value="None">关闭</Option>
								<Option value="All">全局</Option>
								<Option value="Personal">个人</Option>
							</Select>
						</Col>
          </Row>
        </Col>
      </Row>
			<Row type="flex" style="padding: 0px 20px">
			  <Col span="12" v-for="(item,index) in purviewTree" v-if="item.children!=undefined" style="text-align: center;margin-bottom:20px;">
			    <Row type="flex" align="middle" :gutter="5">
			      <Col span="24" style="text-align:left;">
							<span style="font-size:16px">
								<span style="display: inline-block;background-image:url(/img/setting/border-l.png);width:4px;height:16px;vertical-align: middle;"></span>
								{{item.title}}权限
							</span>
							<div style="padding: 5px;"></div>
							<Select v-model="item.type" size="large" transfer-class-name="select-st" style="width:260px;height: 40px;border-radius:20px;">
								<Option value="None">关闭</Option>
								<Option value="All">全局</Option>
								<Option value="Personal">个人</Option>
							</Select>
						</Col>
			    </Row>
			    <row style="margin:10px 0;text-align:left;padding-left:15px;" v-if="item.children!=undefined&&secItem" type="flex" align="middle" v-for="(secItem,secIndex) in item.children">
			      <Col span="8"><span>{{secItem.title}}权限</span></Col>
			      <Col span="7" style="text-align: left">
			        <Select v-model="secItem.type" size="small">
			          <Option value="None">关闭</Option>
			          <Option value="All">全局</Option>
			          <Option value="Personal">个人</Option>
			        </Select>
			      </Col>
			    </row>
			  </Col>
			</Row>
			</div>
    </Modal>
  </div>
</template>

<script>
  export default {
    name: "group",//组权限
    props:{
      createPanel:Boolean,
    },
    data:function() {
      return {
        groupList:[],
        menuList:[],
        createPanelState:false,
        resetPanelState:false,
        setPurviewPanel:false,
        addGroupNameText:"",
        resetGroupInfo:{},
        purviewTree:[],
        groupIdNow:"",
      }
    },
    watch:{
      'createPanel':function (val) {
        this.createPanelState = val
      },
      'createPanelState':function (val) {
        this.$emit('changePanelState',val)
      }
    },
    methods:{
      //获取分组列表
      getGroupList:function () {
        var _this = this
        _this.send({
          headers:"P/PurviewList",
          success:function (res) {
            var tempArr = []
            var i=0
            for(var index in res){
              tempArr[i] = {}
              tempArr[i].name=res[index].PurviewName
              tempArr[i].id=res[index].PurviewId
              tempArr[i].change=res[index].EditAble
              i++
            }
            _this.groupList = tempArr
          }
        })
      },
      //重命名
      resetGroupName:function(){
        var _this = this
        _this.send({
          headers:'P/UpdatePurview',
          data:{
            PurviewName:_this.resetGroupInfo.name,
            PurviewId:_this.resetGroupInfo.id,
          },
          success:function (res) {
            _this.$Notice.success({
              title:"系统消息",
              desc:"修改成功！",
            })
            _this.getGroupList()
          }
        })
      },
      //设置权限
      setGroupPurview:function(){
        var _this = this
        var sendArr = {
          None:[],
          All:[],
          Personal:[],
        }
        for(var i=0;i<_this.purviewTree.length;i++){
          sendArr[_this.purviewTree[i].type].push(_this.purviewTree[i].id)
          if(_this.purviewTree[i].children!=undefined){
            for(var j=0;j<_this.purviewTree[i].children.length;j++){
              sendArr[_this.purviewTree[i].children[j].type].push(_this.purviewTree[i].children[j].id)
            }
          }
        }
        _this.send({
          headers:'P/UpdatePurview',
          data:{
            PersonPurview:sendArr.Personal.toString(),
            PurviewAll:sendArr.All.toString(),
            PurviewId:_this.groupIdNow,
          },
          success:function (res) {
            _this.$Notice.success({
              title:"系统消息",
              desc:"设置权限成功！",
            })
          }
        })
      },
      //打开权限面板
      openPurviewPanel:function(id){
        var _this = this
        _this.getPurviewList(id)
      },
      //获取权限列表
      getPurviewList:function(id){
        var _this = this
        _this.send({
          headers:'P/PurviewMenuList',
          data:{
            PurviewId:id,
          },
          success:function (res) {
            var treeArr = []
            var i = 0
            for(var index in res){
              treeArr[i] = {}
              treeArr[i].title=res[index].MenuName
              treeArr[i].id = res[index].MenuId
              treeArr[i].type = res[index].Type
              if(res[index].List != undefined){
                treeArr[i].children = []
                for(var secIndex in res[index].List){
                  treeArr[i].children.push({
                    title:res[index].List[secIndex].MenuName,
                    id:res[index].List[secIndex].MenuId,
                    type:res[index].List[secIndex].Type,
                  })
                }
              }
              i++
            }
            _this.purviewTree = treeArr
            _this.groupIdNow = id
            _this.setPurviewPanel = true
          }
        })
      },
      //获取菜单列表
      getMenuList:function () {
        var _this = this
        _this.send({
          headers:'P/PurviewMenuList',
          success:function (res) {
            console.log(res)
            return
            var tempArr = []
            var i=0
            var j=0
            for(var index in res){
              tempArr[i] = {}
              tempArr[i].title = res[index].MenuName
              tempArr[i].menuId = res[index].MenuId
              if(res[index].List!=undefined){
                tempArr[i].children = []
                for(var secIndex in res[index].List){
                  tempArr[i].children[j] = {}
                  tempArr[i].children[j].title = res[index].List[secIndex].MenuName
                  tempArr[i].children[j].name = res[index].List[secIndex].MenuRoute
                  tempArr[i].children[j].menuId = res[index].List[secIndex].MenuId
                  j++
                }
              }else{
                tempArr[i].name = res[index].MenuRoute
              }
              i++
            }
            _this.menuList = tempArr
          }
        })
      },
      //新增权限组
      addGroup:function(){
        var _this = this
        _this.send({
          headers:'P/UpdatePurview',
          data:{
            PurviewName:_this.addGroupNameText,
          },
          success:function (res) {
            _this.getGroupList()
            _this.$Notice.success({
              title:"系统消息",
              desc:"添加成功！",
            })
            _this.addGroupNameText = ""
          }
        })
      },
      //删除权限组
      deleteGroup:function (delId) {
        var _this = this
        _this.send({
          headers:'P/DeletePurview',
          confirm:true,
          data:{
            PurviewId:delId,
          },
          success:function () {
            _this.getGroupList()
          }
        })
      }
    },
    mounted:function () {
      this.getGroupList()
      // this.getMenuList()
    }
  }
</script>
